import classNames from "classnames";
import { profilePic } from "../../assets/images";
import { addFolderIcon, editIcon, checkBlackIcon } from "../../assets/icons";
import { INTERFACES } from "../organisms/AppDrawers/drawers.constants";
import { INDEX, FILE_PROPERTIES, REGEX } from "../../constants";

const { FILE } = INTERFACES;
const { SECOND } = INDEX;
const { FILE_NAME_FROM_URL } = REGEX;
const { NAME, BASE_64_URL } = FILE_PROPERTIES;
const STRING = "string";
const HTTPS = "https";

const FileRenderer = (props, field) => {
  const uploadedFile = props.value || field.schema.defaultValue;

  const getFileProperty = (property) => {
    const isURL =
      typeof uploadedFile === STRING && uploadedFile.startsWith(HTTPS);

    if (isURL) {
      const uploadedFileName = uploadedFile.match(FILE_NAME_FROM_URL)[SECOND];
      return property === NAME
        ? decodeURIComponent(uploadedFileName)
        : uploadedFile;
    }

    return (
      uploadedFile?.[property] ||
      (uploadedFile && JSON.parse(uploadedFile)[property])
    );
  };

  const emptyFieldIcon =
    field.meta.interface === FILE ? addFolderIcon : profilePic;
  const icon = uploadedFile ? getFileProperty(BASE_64_URL) : emptyFieldIcon;

  return (
    <div className="group h-full w-full flex items-center gap-2">
      <img
        src={icon}
        alt="user-pic"
        className={classNames("h-8 w-8 rounded-full", {
          "m-auto": !uploadedFile,
          hidden: field.meta.interface === FILE && uploadedFile,
        })}
      />
      <span
        className={classNames("truncate ... pr-5", {
          "pr-4 text-black": props.cellStartedEdit,
          hidden: !uploadedFile,
        })}
      >
        {uploadedFile && getFileProperty(NAME)}
      </span>
      <img
        src={editIcon}
        alt="edit-icon"
        className={classNames(
          "absolute right-2 top-3 hidden group-hover:block w-4 h-4 group-hover:cursor-pointer",
          { hidden: props.cellStartedEdit }
        )}
      />
      <img
        src={checkBlackIcon}
        alt="check-icon"
        className={classNames("absolute right-2 top-3 w-4 h-4 cursor-pointer", {
          hidden: !props.cellStartedEdit,
        })}
        onClick={() => props.api.stopEditing()}
      />
    </div>
  );
};

export default FileRenderer;
